import React, { Component } from 'react'
import './css/intro.css'
import Footer from './footer'
import { Icon } from 'semantic-ui-react'
import { Row } from 'react-bootstrap'

export class intro extends Component {
  render () {
    return (
      <>
        <div id='img1'>
          <div id='me'>
            <div>
              <h3>Hi there,</h3>
              <h1>this is Abhinav Srivastava</h1>
              <Row className='justify-content-center'>
                <Icon name='location arrow' size='big' />
                <h3>India</h3>
              </Row>
            </div>
          </div>
        </div>
        <div className='about' id='intro'>
          <div className='sub-about'>
            <h2>Hello.</h2>
            <h4>I am a raising Engineer in Computer Science. Currently a junior, and persuing Bachelors degree in the same, acquiring knowlege and skills of Computer software and sometimes hardware. Majorly I do development and
            spend most of my time in developing web-applications using MERN stack and applications using a cross-platform framework namely Flutter. Apart from that my interests dive deeply in
            security and sometimes competitive coding. Apart from all this I can play games all day long <span role='img' aria-label='smile'>&#128515;</span>
            </h4>
          </div>
        </div>
        <Footer />
      </>
    )
  }
}

export default intro
